// returns array of provider names from array of provider objects
export const convertProvidersToNames = (providers) =>
	providers.map(({ provider }) => provider);

// returns array of provider names from array of provider objects
export const convertProvidersToId = (providers) =>
	providers.map(({ provider_id }) => provider_id);
